import { useState } from "react";

const ChangeCourseDateModal = ({ registrationId }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [customDate, setCustomDate] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async () => {
    try {
      const res = await fetch("https://www.denisbitter.de/stage01/api/update_course_date.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          registrationId,
          custom_date: customDate,
        }),
      });

      const rawText = await res.text();
      let result;
      try {
        result = JSON.parse(rawText);
      } catch (jsonErr) {
        setMessage("Fehlerhafte Antwort vom Server.");
        return;
      }

      setMessage(result.message);
      if (result.success) {
        setTimeout(() => {
          setIsOpen(false);
          window.location.reload();
        }, 1500);
      }
    } catch (err) {
      setMessage("Verbindungsfehler.");
    }
  };

  const btnClass =
    "w-full py-2 text-xs font-mono text-[#AC8E66] bg-[#1c1c1c] border border-[#AC8E66]/30 rounded hover:border-[#AC8E66]/60 hover:bg-[#1e1e1e] transition-all cursor-pointer";

  return (
    <>
      <button className={btnClass} onClick={() => setIsOpen(true)}>
        [ kursdatum aendern → ]
      </button>

      {isOpen && (
        <div className="fixed inset-0 bg-[#121212]/95 backdrop-blur-sm flex items-center justify-center z-50" onClick={() => setIsOpen(false)}>
          <div className="w-full max-w-md mx-4" onClick={(e) => e.stopPropagation()}>
            <div className="rounded-lg border border-[#AC8E66]/20 overflow-hidden shadow-2xl shadow-black/40">
              <div className="flex items-center gap-2 px-4 py-2.5 bg-[#1a1a1a] border-b border-[#AC8E66]/10">
                <span className="w-3 h-3 rounded-full bg-[#ff5f57] cursor-pointer" onClick={() => setIsOpen(false)} />
                <span className="w-3 h-3 rounded-full bg-[#febc2e]" />
                <span className="w-3 h-3 rounded-full bg-[#28c840]" />
                <span className="ml-3 text-xs text-[#AC8E66] select-none">datum</span>
              </div>
              <div className="px-5 sm:px-6 py-5 bg-[#151515] font-mono">
                <p className="text-sm text-[#EFEBDC]/50 mb-4">
                  <span className="text-[#AC8E66]">$</span> date --change
                </p>
                <input
                  type="date"
                  className="w-full bg-[#1c1c1c] border border-[#AC8E66]/20 rounded px-3 py-2.5 text-sm text-[#EFEBDC] font-mono focus:outline-none focus:border-[#AC8E66]/50 transition-colors mb-4"
                  value={customDate}
                  onChange={(e) => setCustomDate(e.target.value)}
                />
                <button className={btnClass} onClick={handleSubmit}>
                  [ speichern → ]
                </button>
                {message && (
                  <p className="text-xs text-green-400/70 mt-3">
                    <span className="text-[#AC8E66]/80">&gt;</span> {message}
                  </p>
                )}
                <button
                  className="mt-3 text-xs text-[#EFEBDC]/30 hover:text-[#EFEBDC]/60 font-mono w-full text-center cursor-pointer transition-colors"
                  onClick={() => setIsOpen(false)}
                >
                  [ abbrechen ]
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ChangeCourseDateModal;
